import React from 'react'

import { Table, Form } from '_zari/core'

const CheckboxCell = ({ row, checked, handleChange }) => {
  const onChange = React.useCallback(() => {
    handleChange(row._id)
  }, [row, handleChange])

  return (
    <Table.Cell>
      <Form.Checkbox
        id={`checkbox-modal-${row._id}`}
        name={`checkbox-modal-${row._id}`}
        checked={checked}
        onChange={onChange}
      />
    </Table.Cell>
  )
}

export default React.memo(CheckboxCell)
